import Basic from './Basic';
export type { BasicTopNavigationProps } from './Basic';

export default {
  Basic
};
